import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  BillingOverview,
  CompanyBilling,
  CompanyPaymentMethodInput,
} from "../models/Billing/BillingModels";

class BillingApi extends BaseApi {
  public getSubscription = BaseApi.createEndpoint<BillingOverview, null>(
    HttpMethodEnum.GET,
    "/billing/subscription",
  );

  public updatePaymentMethod = BaseApi.createEndpoint<
    CompanyBilling,
    { paymentMethod: CompanyPaymentMethodInput }
  >(HttpMethodEnum.PUT, "/billing/payment-method");
}

export const billingApi = new BillingApi();
